import { config } from '../config'
import { JuridischLoketBotservice } from '../generated/src/juridischLoketBotservice'

export const apiService = new JuridischLoketBotservice({
  baseUri: config.api,
})
